import { BrowserRouter as Router, Routes, Route, Navigate, useRoutes } from 'react-router-dom';
import './App.css';
import ScrollToTop from './ScrollToTop';
// Legacy onboarding (SurveyOne/SurveyTwo/StepOne-Five, Aug 2023) removed from frontend.
// Files remain on disk; delete manually if a future cleanup is desired.
import React, { useState, useEffect } from 'react';
import SignUp from './SignUp';
import store from './Redux/store';
import { Provider } from 'react-redux';
import { auth } from './firebaseConfig';
import ForgotPassword from './ForgotPassword';
import AdminHome from './AdminComponents/AdminHome.js';
import TeamSyncAdmin from './AdminComponents/TeamSyncAdmin';
import AdminConfigSettings from './BackendSurvey/AdminConfigSettings';
import NewsletterSettings from './BackendSurvey/NewsletterSettings'; // Nehmen Sie an, dass dies der korrekte Pfad ist // Nehmen Sie an, dass dies der korrekte Pfad ist
import AppBackend from './BackendSurvey/AppBackend';
import NewsletterBackend from './BackendSurvey/NewsletterBackend';
import VoucherStatusPage from './BackendSurvey/VoucherStatusPage';
import TeamDashboard from './TeamDashboard/TeamDashboard';
import { database } from "./firebaseConfig";
import { ref, onValue } from 'firebase/database';

// Import Cloudflare Proxy Tester for development/testing
import './utils/cloudflareProxyTester';
import EmailTemplates from './BackendSurvey/EmailTemplates';
import { FontProvider } from './Design/FontContext';
import { TeamProvider } from './contexts/TeamContext';
import ActivityHeartbeat from './components/ActivityHeartbeat';
import BonusIdeas from './AdminComponents/BonusIdeas';
import AddPageComponent from './Pages/AddPageComponent';
import Home from './Pages/Home';
import AddDemoComponent from './Pages/Demo/AddDemoComponent';
import PageSettings from './Pages/PageSettings'; // Ihre Seiteneinstellungs-Komponente
import SpaceSettings from './Pages/SpaceSettings'; // Space Settings Page
import PagePublic from './Pages/PagePublic'; // Ihre öffentliche Seitenansichts-Komponente
import MyTemplates from './Pages/MyTemplates'; // My Templates Page
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import Concierge from './Pages/Concierge';
import AcademyViewer from './Academy/AcademyViewer';
import TemplateSelector from './Pages/TemplateSelector';
import UserSettings from './Pages/UserSettings';
import DemoPageSettings from './Pages/Demo/DemoPageSettings';
import DemoPagePublic from './Pages/Demo/DemoPagePublic';
import Layouts from './Pages/Demo/Layouts';
import QRStatusPage from './BackendSurvey/QRStatusPage';
// Agency feature retired — files deleted; route /agency removed.
import ChatList from './Pages/Chats/ChatList';
import DigitalBrandbook from './Pages/Brandbook/DigitalBrandbook';
import TeamChatList from './Pages/Chats/TeamChatList';
import { UnreadStatusProvider } from './Pages/Chats/UnreadStatusContext';
import WelcomeInfos from './Pages/WelcomeInfos';
import SuccessPage from './AdminComponents/SuccessPage';
import MarketingDatabase from './TeamDashboard/MarketingDatabase';
import WorldDash from './WorldDash/WorldDash'; // Importiere die WorldDash-Komponente
import WorldDb from './WorldDash/WorldDb'; // Importiere die WorldDb-Komponente
import WorldLayout from './WorldDash/WorldLayout';
import TasksPage from './WorldDash/tasks/TasksPage'; // Shared Layout für World/Leads (verhindert Header-Flackern)
import LeadSwipe from './WorldDash/LeadSwipe'; // LeadSwipe - Tinder-style Flow-Übersicht
import DealWizardPage from './WorldDash/DealWizardPage'; // Deal Wizard Seite
import ValueBasedOfferPage from './WorldDash/ValueBasedOfferPage'; // Value-Based Offer (Claude Opus)
import ValueBasedOfferPublic from './WorldDash/OfferCreator/ValueBasedOffer/ValueBasedOfferPublic'; // Public, shareable preview
import MiniAppPublic from './miniApps/MiniAppPublic';
import CustomOfferView from './WorldDash/OfferCreator/CustomOfferView/CustomOfferView'; // Import für die öffentliche Angebotsansicht
import CustomContractView from './WorldDash/OfferCreator/CustomContractView/CustomContractView'; // Import für die öffentliche Vertragsansicht
import { HelmetProvider } from 'react-helmet-async';
import UnlockPage from './Pages/UnlockPage';
import LegalPage from './Pages/LegalPage';
import ProtectedRoute from './Pages/ProtectedRoute';
import DealsRoute from './Pages/DealsRoute';
import StoriesMain from './Stories/StoriesMain';
import SharedIdeaList from './Stories/SharedIdeaList';
import ProductDashboard from './SalesPlatform/Pages/ProductDashboard';
import ProductSettings from './SalesPlatform/Pages/ProductSettings';
import EmailFlowDashboard from './EmailFlow/Pages/EmailFlowDashboard';
import EmailDesigner from './EmailFlow/Pages/EmailDesigner';
import BusinessAnalysisDashboard from './BusinessAnalysis/Pages/BusinessAnalysisDashboard';
import BusinessAnalysisAdd from './BusinessAnalysis/Pages/BusinessAnalysisAdd';
import BusinessAnalysisPreview from './BusinessAnalysis/Pages/BusinessAnalysisPreview';
import BusinessAnalysisCompare from './BusinessAnalysis/Pages/BusinessAnalysisCompare';
import BusinessAnalysisPublic from './BusinessAnalysis/Pages/BusinessAnalysisPublic';
import CustomDomainRouter from './Pages/CustomDomainRouter';
import { isCustomDomain } from './utils/domainHelpers';
import { initializeSplashManager, signalReactReady } from './utils/splashManager';
import GenerateHome from './Generate/GenerateHome';
import YoutubeStoryteller from './Generate/YoutubeStoryteller';
import YoutubeScriptEditor from './Generate/YoutubeScriptEditor';
import { InboxSendJobsProvider } from './contexts/InboxSendJobsContext';
import InboxSendingBar from './components/InboxSendingBar';


function RoutesWithTransitions({ isAuthenticated, setIsAuthenticated }) {
  const [isInitialized, setIsInitialized] = useState(false);
  const [hasWorldAccess, setHasWorldAccess] = useState(false);
  const [isWorldAccessChecked, setIsWorldAccessChecked] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const [isAdmin, setIsAdmin] = useState(false);
  // Aktive Auth-UID als State, damit Listener-useEffects bei Auth-Wechseln
  // (z. B. signInWithCustomToken für Sub-Worlds) korrekt re-attachen.
  const [authUid, setAuthUid] = useState(null);

  const canAccessTeamDashboard = () => {
    return isAdmin;
};

  useEffect(() => {
      const unsubscribe = auth.onAuthStateChanged(async (user) => {
          if (user) {
              setIsAuthenticated(true);
              setAuthUid(user.uid);
              // Admin-Status aus Custom Claims laden
              try {
                const tokenResult = await user.getIdTokenResult();
                setIsAdmin(tokenResult.claims.admin === true);
              } catch (err) {
                console.error('Failed to check admin claims:', err);
                setIsAdmin(false);
              }
          } else {
              setIsAuthenticated(false);
              setAuthUid(null);
              setIsAdmin(false);
          }
          setIsInitialized(true);
      });

      return () => unsubscribe();
  }, [setIsAuthenticated]);
  
  useEffect(() => {
    if (isAuthenticated && authUid) {
        const surveyRef = ref(database, `surveyConfigs/${authUid}`);
        
        // Performance: Timeout für surveyConfigs Listener
        const timeoutPromise = new Promise((_, reject) => 
            setTimeout(() => reject(new Error('SurveyConfigs timeout')), 3000)
        );
        
        const listener = onValue(surveyRef, snapshot => {
            try {
                if (snapshot.exists()) {
                    const data = snapshot.val();
                    if (data.surveyPrimaryColor) {
                        document.documentElement.style.setProperty('--blue', data.surveyPrimaryColor);
                    }
                }
            } catch (error) {
                console.warn('SurveyConfigs loading error:', error);
            }
        }, (error) => {
            console.warn('SurveyConfigs listener error:', error);
        });
        
        // Race zwischen Firebase und Timeout
        Promise.race([
            new Promise(resolve => setTimeout(resolve, 100)), // Minimal delay
            timeoutPromise
        ]).catch(() => {
            console.warn('SurveyConfigs loading timeout - using defaults');
        });
        
        // Cleanup: `onValue` (v9 modular) liefert direkt die Unsubscribe-Funktion
        // zurück. Vorher stand hier `off(ref, 'value', listener)`, was nichts
        // detachte (off() braucht den ORIGINAL data-callback, nicht die
        // Unsubscribe-Funktion). Folge: alte Listener blieben am Parent-Knoten
        // hängen und feuerten beim Sub-World-Wechsel permission_denied,
        // wodurch hasWorldAccess fälschlich auf false gesetzt wurde.
        return () => {
            listener();
        };
    }
  }, [isAuthenticated, authUid]);

  // Echtzeit-Listener für World-Zugriff (reagiert sofort auf Änderungen wie Team-Einladungen)
  // Wichtig: dep `authUid` damit Listener bei Auth-Wechsel (Sub-World ↔ Parent) re-attachen.
  useEffect(() => {
    if (!isAuthenticated || !authUid) {
      setHasWorldAccess(false);
      // Only mark as checked once auth is initialized,
      // otherwise the loading screen disappears before we know the real access state
      if (isInitialized) {
        setIsWorldAccessChecked(true);
      }
      return;
    }

    const userId = authUid;
    const userRef = ref(database, `Users/${userId}`);

    const unsubscribeWorld = onValue(userRef, (snapshot) => {
      try {
        if (snapshot.exists()) {
          const userData = snapshot.val();

          const isOwnerWithWorld = userData.hasSalesGod === true;

          let isTeamMemberWithWorldAccess = false;

          if (userData.teamMemberships) {
            isTeamMemberWithWorldAccess = Object.values(userData.teamMemberships).some(membership =>
              membership.status === 'accepted' &&
              membership.features?.some(f => ['leads', 'inbox', 'offers', 'all'].includes(f))
            );
          }

          // LEGACY: teamMembership (singular)
          if (!isTeamMemberWithWorldAccess && userData.teamMembership?.teamId) {
            isTeamMemberWithWorldAccess = userData.teamMembership.features?.some(f =>
              ['leads', 'inbox', 'offers', 'all'].includes(f)
            );
          }

          setHasWorldAccess(isOwnerWithWorld || isTeamMemberWithWorldAccess);
        } else {
          setHasWorldAccess(false);
        }
      } catch (error) {
        console.error("Fehler beim Prüfen des World-Zugriffs:", error);
        setHasWorldAccess(false);
      }

      setIsWorldAccessChecked(true);
    }, (error) => {
      console.error("World-Zugriff Listener Fehler:", error);
      setHasWorldAccess(false);
      setIsWorldAccessChecked(true);
    });

    // Siehe Kommentar oben: `unsubscribeWorld` ist bereits die Unsubscribe-
    // Funktion, NICHT der Daten-Callback. Direkt aufrufen, sonst bleiben
    // alte Listener am Parent-Knoten kleben und der Sub-World-User triggert
    // beim Re-Mount permission_denied → setHasWorldAccess(false) → /world
    // wird nach / weitergeleitet → Home redirected zu /dashboard → Loop.
    return () => {
      unsubscribeWorld();
    };
  }, [isAuthenticated, isInitialized, authUid]);

  // Separater useEffect für Loading-State Management
  useEffect(() => {
    if (isInitialized && isWorldAccessChecked) {
      setIsLoading(false);
    }
  }, [isInitialized, isWorldAccessChecked]);

  // Zeige Ladebildschirm, bis alle Prüfungen abgeschlossen sind
  if (!isInitialized || isLoading) {
    
    const currentPath = window.location.pathname;
    
    // SalesGod Loading für /world/* und /leads Routen (Network, Targets, etc.)
    const isWorldRoute = currentPath.startsWith('/world') || currentPath.startsWith('/leads');
    if (isWorldRoute) {
      return (
        <>
          <style>{`
            @keyframes salesgod-gradient {
              0% { background-position: 0% 50%; }
              50% { background-position: 100% 50%; }
              100% { background-position: 0% 50%; }
            }
            @keyframes salesgod-rotate {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
            @keyframes salesgod-pulse {
              0%, 100% { opacity: 1; }
              50% { opacity: 0.6; }
            }
          `}</style>
          <div style={{ 
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            height: '100vh',
            background: 'linear-gradient(45deg, #ffffff, #f8fbff, #e8f4fd, #ffffff)',
            backgroundSize: '400% 400%',
            animation: 'salesgod-gradient 1s ease infinite'
          }}>
            <div style={{
              width: '100px',
              height: '100px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginBottom: '20px',
              animation: 'salesgod-rotate 2s linear infinite'
            }}>
              <img 
                src="/img/salesgod_dark.webp" 
                alt="SalesGod" 
                style={{ width: '60px', height: '60px', borderRadius: '50%', objectFit: 'contain' }}
              />
            </div>
            <div style={{
              fontSize: '18px',
              fontWeight: '600',
              color: '#3182ce',
              fontFamily: 'Inter, sans-serif',
              animation: 'salesgod-pulse 1s ease-in-out infinite'
            }}>
              Loading...
            </div>
          </div>
        </>
      );
    }
    
    // Check if this is a public page route (should have minimal branding)
    const isPublicPage = currentPath.includes('/') && currentPath.split('/').length >= 2 && 
                        !currentPath.startsWith('/pages') && 
                        !currentPath.startsWith('/space-settings') &&
                        !currentPath.startsWith('/world');
    
    if (isPublicPage) {
      // Ultra-minimal loading for public pages (just spinner, no text)
      return (
        <>
          <style>{`
            @keyframes app-spinner-spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `}</style>
          <div className="loading-spinner" style={{ 
            display: 'flex', 
            justifyContent: 'center', 
            alignItems: 'center', 
            height: '100vh',
            background: '#ffffff'
          }}>
            <div className="spinner-circle" style={{
              width: '32px',
              height: '32px',
              border: '3px solid #f3f4f6',
              borderTop: '3px solid #6366f1',
              borderRadius: '50%',
              animation: 'app-spinner-spin 1s linear infinite'
            }}></div>
          </div>
        </>
      );
    }
    
    // Full BonusClub branding for admin/internal pages
    return (
      <div className="loading-spinner">
        <h1>BonusClub</h1>
        <div className="spinner-circle"></div>
      </div>
    );
  }

  return (
    <FontProvider>
         <UnreadStatusProvider>
        <div className="route-section">
            <Routes>
                {/* Custom Domain Routes - Only for external domains */}
                {(() => {
                    const isCustom = isCustomDomain();
                    
                    if (isCustom) {
                        return (
                            <>
                                <Route path="/" element={<CustomDomainRouter />} />
                                <Route path="/*" element={<CustomDomainRouter />} />
                            </>
                        );
                    } else {
                        return (
                            <>
                                {/* Öffentliche Routen */}
                                {/* /survey and /surveytwo removed (legacy 2023 onboarding) */}
                                <Route path="/success" element={<SuccessPage />} />
                                <Route path="/custom-offer/:customId" element={<CustomOfferView />} />
                                <Route path="/custom-contract/:customId" element={<CustomContractView />} />
                                <Route path="/v/:customId" element={<ValueBasedOfferPublic />} />
                                <Route path="/miniapp/:publicId" element={<MiniAppPublic />} />
                                <Route path="/shared/:shareToken" element={<SharedIdeaList />} />
                                
                                {/* Unified /to/ System Routes - Handles both legacy and new space system */}
                                <Route path="/to/:customRoute" element={<PagePublic />} />           {/* Legacy: /to/customRoute */}
                                <Route path="/to/:username/" element={<PagePublic />} />             {/* New: /to/username/ (Home) */}
                                <Route path="/to/:username/:pagename" element={<PagePublic />} />    {/* New: /to/username/pagename */}
                            </>
                        );
                    }
                })()}

                {/* Admin/Backend Routes - Only for BonusClub domains */}
                {!isCustomDomain() && (
                    <>
                        {/* Signup Route nur für nicht-authentifizierte Benutzer */}
                        {!isAuthenticated ? (
                            <Route path="/signup" element={<SignUp setIsAuthenticated={setIsAuthenticated} />} />
                        ) : (
                            <Route path="/signup" element={<Navigate to="/" replace />} />
                        )}
                        <Route path="/forgot-password" element={<ForgotPassword />} />
                        <Route path="/survey/:userId" element={<AppBackend />} />
                        <Route path="/news/:userId" element={<NewsletterBackend />} />
                        <Route path="/updateStatus" element={<VoucherStatusPage />} />
                        <Route path="/qr" element={<QRStatusPage />} />

                        {/* Rechtsseiten: ohne Login erreichbar, deutsche und englische Pfade */}
                        <Route path="/impressum" element={<LegalPage document="imprint" />} />
                        <Route path="/imprint" element={<LegalPage document="imprint" />} />
                        <Route path="/datenschutz" element={<LegalPage document="privacy" />} />
                        <Route path="/privacy" element={<LegalPage document="privacy" />} />
                        <Route path="/agb" element={<LegalPage document="terms" />} />
                        <Route path="/terms" element={<LegalPage document="terms" />} />
                        <Route path="/avv" element={<LegalPage document="dpa" />} />
                        <Route path="/dpa" element={<LegalPage document="dpa" />} />
                    </>
                )}

                {/* Routen für authentifizierte Benutzer - Only for BonusClub domains */}
                {isAuthenticated && !isCustomDomain() && (
                    <>
                        <Route path="/demo/:customRoute" element={<DemoPagePublic />} />
                        <Route path="/social" element={<ProtectedRoute><AdminHome /></ProtectedRoute>} />
                        {/* /agency route removed with Agency feature retirement */}
                        <Route path="/chat" element={<ProtectedRoute><ChatList /></ProtectedRoute>} />
                        <Route path="/teamchat" element={<ProtectedRoute><TeamChatList /></ProtectedRoute>} />
                        <Route path="/brand" element={<ProtectedRoute><DigitalBrandbook /></ProtectedRoute>} />
                        <Route path="/layouts" element={<Layouts />} />
                        <Route path="/settings/page/:pageId/templates" element={<TemplateSelector />} />
                        <Route path="/settings" element={<AdminConfigSettings />} />
                        <Route path="/concierge" element={<Concierge />} />
                        <Route path="/newsletter" element={<NewsletterSettings />} />
                        <Route path="/emails" element={<EmailTemplates />} />
                        <Route path="/ideas" element={<BonusIdeas />} />
                        <Route path="/welcome" element={<WelcomeInfos />} />
                        <Route path="/unlock" element={<UnlockPage />} />
                        <Route path="/user-settings" element={<ProtectedRoute><UserSettings /></ProtectedRoute>} />
                        <Route path="/admin/team-sync" element={<ProtectedRoute><TeamSyncAdmin /></ProtectedRoute>} />
                        <Route path="/stories" element={<ProtectedRoute><StoriesMain /></ProtectedRoute>} />
                        <Route path="/deals" element={<DealsRoute><DealWizardPage /></DealsRoute>} />
                        <Route path="/deals/:offerId" element={<DealsRoute><DealWizardPage /></DealsRoute>} />
                        <Route path="/value-offer" element={<DealsRoute><ValueBasedOfferPage /></DealsRoute>} />
                        <Route path="/value-offer/:offerId" element={<DealsRoute><ValueBasedOfferPage /></DealsRoute>} />
                        <Route path="/sales" element={<ProtectedRoute><ProductDashboard /></ProtectedRoute>} />
                        <Route path="/sales/product/:productId" element={<ProtectedRoute><ProductSettings /></ProtectedRoute>} />
                        <Route path="/emailflow" element={<ProtectedRoute><EmailFlowDashboard /></ProtectedRoute>} />
                        <Route path="/emailflow/template/:templateId" element={<ProtectedRoute><EmailDesigner /></ProtectedRoute>} />
                        <Route path="/business-analysis" element={<ProtectedRoute><BusinessAnalysisDashboard /></ProtectedRoute>} />
                        <Route path="/business-analysis/add" element={<ProtectedRoute><BusinessAnalysisAdd /></ProtectedRoute>} />
                        <Route path="/business-analysis/edit/:analysisId" element={<ProtectedRoute><BusinessAnalysisAdd /></ProtectedRoute>} />
                        <Route path="/business-analysis/view/:analysisId" element={<ProtectedRoute><BusinessAnalysisPreview /></ProtectedRoute>} />
                        <Route path="/business-analysis/compare" element={<ProtectedRoute><BusinessAnalysisCompare /></ProtectedRoute>} />
                        <Route path="/business-analysis/public/:shareToken" element={<BusinessAnalysisPublic />} />
                        <Route path="/generate" element={<ProtectedRoute><GenerateHome /></ProtectedRoute>} />
                        <Route path="/generate/youtube-storyteller" element={<ProtectedRoute><YoutubeStoryteller /></ProtectedRoute>} />
                        <Route path="/generate/youtube-script/:scriptId" element={<ProtectedRoute><YoutubeScriptEditor /></ProtectedRoute>} />
                        <Route path="/academy" element={<ProtectedRoute><AcademyViewer /></ProtectedRoute>} />
                        <Route path="/academy/:categoryId" element={<ProtectedRoute><AcademyViewer /></ProtectedRoute>} />
                        <Route path="/my-templates" element={<ProtectedRoute><MyTemplates /></ProtectedRoute>} />
                        <Route path="/" element={<ProtectedRoute><Home /></ProtectedRoute>} />
                        <Route path="/dashboard" element={<ProtectedRoute><Home showDashboard={true} /></ProtectedRoute>} />
                        <Route path="/pages" element={<ProtectedRoute><AddPageComponent /></ProtectedRoute>} />
                            <Route path="/settings/page/:pageId" element={<ProtectedRoute><PageSettings /></ProtectedRoute>} />
                            <Route path="/settings/page/:userId/:pageName" element={<ProtectedRoute><PageSettings /></ProtectedRoute>} />
                            <Route path="/settings/page/:userId/:spaceId/:pageName" element={<ProtectedRoute><PageSettings /></ProtectedRoute>} />
                            <Route path="/space-settings/:spaceId" element={<ProtectedRoute><SpaceSettings /></ProtectedRoute>} />
                            <Route path="/space/:spaceId" element={<ProtectedRoute><AddPageComponent /></ProtectedRoute>} />
                        <Route path="/settings/demoPage/:pageId" element={<DemoPageSettings />} />
                        
                        {/* Zugriff auf TeamDashboard nur für erlaubte E-Mail-Adressen */}
                        {canAccessTeamDashboard() ? (
                          <Route path="/teamdashboard" element={<TeamDashboard />} />
                        ) : (
                          <Route path="/teamdashboard" element={<Navigate to="/" replace />} />
                        )}
                        {canAccessTeamDashboard() ? (
                          <Route path="/demos" element={<AddDemoComponent />} />
                        ) : (
                          <Route path="/demos" element={<Navigate to="/" replace />} />
                        )}
                        {canAccessTeamDashboard() ? (
                          <Route path="/settings/demoPage/:pageId" element={<DemoPageSettings />} />
                        ) : (
                          <Route path="/settings/demoPage/:pageId" element={<Navigate to="/" replace />} />
                        )}
                        {canAccessTeamDashboard() ? (
                          <Route path="/teamdatabase" element={<MarketingDatabase />} />
                        ) : (
                          <Route path="/teamdatabase" element={<Navigate to="/" replace />} />
                        )}
                        {canAccessTeamDashboard() ? (
                          <Route path="/teamdashboard" element={<TeamDashboard />} />
                        ) : (
                          <Route path="/teamdashboard" element={<Navigate to="/" replace />} />
                        )}
                        
                        {/* World & Leads Routes mit shared Layout (verhindert Header-Flackern) */}
                        {hasWorldAccess ? (
                          <Route element={<WorldLayout />}>
                            <Route path="/world" element={<WorldDb />} />
                            <Route path="/offers/:offerId" element={<WorldDb />} />
                            <Route path="/leads" element={<Navigate to="/world?view=leads" replace />} />
                            <Route path="/leadswipe" element={<LeadSwipe />} />
                            <Route path="/tasks" element={<TasksPage />} />
                          </Route>
                        ) : (
                          <>
                            <Route path="/world" element={<Navigate to="/" replace />} />
                            <Route path="/offers/:offerId" element={<Navigate to="/" replace />} />
                            <Route path="/leads" element={<Navigate to="/" replace />} />
                            <Route path="/leadswipe" element={<Navigate to="/" replace />} />
                            <Route path="/tasks" element={<Navigate to="/" replace />} />
                          </>
                        )}
                    </>
                )}

                {/* Catch-All Route - Only for non-custom domains */}
                {!isCustomDomain() && (
                    <>
                        {isAuthenticated ? (
                            <Route path="*" element={<Navigate to="/" replace />} />
                        ) : (
                            <Route path="*" element={<Navigate to="/signup" replace />} />
                        )}
                    </>
                )}
            </Routes>
        </div>
        </UnreadStatusProvider>
    </FontProvider>
);
                } 

function MailerReportPage() {
  return (
    <div style={{minHeight:'100vh',display:'flex',alignItems:'center',justifyContent:'center',fontFamily:"-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Helvetica,Arial,sans-serif",background:'#f4f5f7',color:'#333'}}>
      <div style={{background:'#fff',borderRadius:16,boxShadow:'0 4px 24px rgba(0,0,0,.07)',maxWidth:440,width:'90%',padding:'44px 36px',textAlign:'center'}}>
        <div style={{fontSize:15,fontWeight:600,color:'#1e293b',letterSpacing:'-.3px',marginBottom:28,display:'flex',alignItems:'center',justifyContent:'center',gap:8}}>
          <span style={{width:8,height:8,borderRadius:'50%',background:'#2563eb',display:'inline-block'}}></span>
          mailer-report.eu
        </div>
        <div style={{width:56,height:56,borderRadius:'50%',background:'#2563eb',color:'#fff',fontSize:26,display:'inline-flex',alignItems:'center',justifyContent:'center',marginBottom:20}}>&#9993;</div>
        <h1 style={{fontSize:19,fontWeight:600,color:'#111',marginBottom:10}}>Email Preference Management</h1>
        <p style={{fontSize:14,color:'#555',lineHeight:1.6}}>This service handles email preferences and unsubscribe requests. If you received an email with an unsubscribe link, please use that link directly.</p>
        <p style={{fontSize:12,color:'#aaa',marginTop:24}}>Secure email preference management</p>
      </div>
    </div>
  );
}

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  // Initialize splash manager for custom domains
  useEffect(() => {
    initializeSplashManager();
    
    // Signal React ready after component mounts
    const timer = setTimeout(() => {
      signalReactReady();
    }, 100);
    
    return () => clearTimeout(timer);
  }, []);

  // Global error handler to suppress drag-and-drop errors
  useEffect(() => {
    const handleError = (event) => {
      // Ignore react-beautiful-dnd drop animation errors
      if (event.message && event.message.includes('Cannot finish a drop animating when no drop is occurring')) {
        event.preventDefault();
        return true;
      }
    };

    const handleUnhandledRejection = (event) => {
      // Ignore react-beautiful-dnd related promise rejections
      if (event.reason && 
          (event.reason.message?.includes('Cannot finish a drop animating') ||
           event.reason.toString().includes('Cannot finish a drop animating'))) {
        event.preventDefault();
        return true;
      }
    };

    window.addEventListener('error', handleError);
    window.addEventListener('unhandledrejection', handleUnhandledRejection);

    return () => {
      window.removeEventListener('error', handleError);
      window.removeEventListener('unhandledrejection', handleUnhandledRejection);
    };
  }, []);

  const host = window.location.hostname;
  if (host === 'mailer-report.eu' || host === 'www.mailer-report.eu') {
    return <MailerReportPage />;
  }

  return (
    <Provider store={store}>
      <HelmetProvider>
        <TeamProvider>
          <ActivityHeartbeat />
          <Router>
            <ScrollToTop />
            <DndProvider backend={HTML5Backend}>
              {/* Global inbox send-job registry: keeps the "Sending…" progress
                  card visible in the bottom-right corner across every route,
                  so navigating to Settings mid-send never hides progress. */}
              <InboxSendJobsProvider>
                <div className="App">
                  <RoutesWithTransitions isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated} />
                </div>
                <InboxSendingBar />
              </InboxSendJobsProvider>
            </DndProvider>
          </Router>
        </TeamProvider>
      </HelmetProvider>
    </Provider>
  );
}

export default App;
